// import lazyLoading from '../lazyLoading';

export default {
  name: 'rowanalyzebyid',
  caption: 'Satır Analizi',
  wdm16_id: '',
  icon: 'icon-cursor',
  path: '/rowanalyzebyid',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
